import React from 'react';
import {CustomBoxplot} from './CustomBoxplot';
import {setDashboardChart, removeDashboardChart, deleteChart} from '../../services/ChartService';
import { Link } from "react-router-dom";

import * as d3 from "d3";

class PartBoxplotPanel extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            jwtToken: props.jwtToken,
            boxplotIndex: props.boxplotIndex,
            boxplotData: props.boxplotData,
            hideTableData: true
        };
        // binding
        this.toggleTableData = this.toggleTableData.bind(this);
        this.handleDelete = this.handleDelete.bind(this);
        this.addToDashboard = this.addToDashboard.bind(this);
        this.removeFromDashboard = this.removeFromDashboard.bind(this);
        this.updateParent = this.updateParent.bind(this);
    }

    toggleTableData(){
        if (this.state.hideTableData){
            this.setState({hideTableData: false});
        }  else {
            this.setState({hideTableData: true});
        }
    }

    updateParent(){
        this.props.handleUpdate();
    }

    handleDelete(){
        deleteChart(this.state.jwtToken, this.state.boxplotData.id)
        .then(response =>
            {
                if (response.ok) {
                    this.props.showAlert({
                        type: "success",
                        message: "Boxplot removed successfully."
                    });
                    this.updateParent();
                } else {
                    this.props.showAlert({
                        type: "error",
                        message: "Boxplot could not be removed."
                    });
                }
            }
        );
    }

    addToDashboard(){
        setDashboardChart(this.state.jwtToken, this.state.boxplotData.id)
        .then(response =>
            {
                if (response.ok) {
                    this.props.showAlert({
                        type: "success",
                        message: "Histogram added to dashboard."
                    });
                    this.updateParent();
                } else {
                    this.props.showAlert({
                        type: "error",
                        message: "Histogram could not be added to dashboard."
                    });
                }
            }
        );
    }

    removeFromDashboard(){
        removeDashboardChart(this.state.jwtToken, this.state.boxplotData.id)
        .then(response =>
            {
                if (response.ok) {
                    this.props.showAlert({
                        type: "success",
                        message: "Histogram removed from dashboard."
                    });
                    this.updateParent();
                } else {
                    this.props.showAlert({
                        type: "error",
                        message: "Histogram could not be removed from dashboard."
                    });
                }
            }
        );
    }

    componentDidMount() {
        if (!this.state.boxplotData.boxplotData || Object.keys(this.state.boxplotData.boxplotData).length === 0) return;

        // render boxplot SVG
        let boxplot = CustomBoxplot(this.state.boxplotData.boxplotData, {
            width: 800,
            height: 250,
            barLegend: this.state.boxplotData.targetVariable,
            xAxisLegend: this.state.boxplotData.filterVariable
        });

        d3.select("#boxplot" + this.state.boxplotIndex).html(boxplot.outerHTML);
    }

    render() {
        const hasData = this.state.boxplotData.boxplotData && Object.keys(this.state.boxplotData.boxplotData).length > 0;
        var renderedDataTables = [];

        // build CI tables
        if (hasData) {
            var dataKeys = Object.keys(this.state.boxplotData.boxplotData);

            for (var i = 0; i < dataKeys.length; i++) {
                let data = this.state.boxplotData.boxplotData[dataKeys[i]];
                let table = (
                    <table key={i} className="table table-bordered" style={{width:"560px"}}>
                        <thead className="thead-dark">
                            <tr>
                                <th style={{width:"180px"}}>Filter variable value</th>
                                <th style={{width:"400px"}} colSpan="2" >Data</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td rowSpan="5" style={{textAlign:"center", verticalAlign:"middle"}}>{dataKeys[i]}</td>
                                <td style={{width:"30%"}}>Geometric mean</td>
                                <td>{data.geometricMean}</td>
                            </tr>
                            <tr>
                                <td >Arithmetic mean</td>
                                <td>{data.arithmeticMean}</td>
                            </tr>
                            <tr>
                                <td>Upper bound</td>
                                <td>{data.upperBound}</td>
                            </tr>
                            <tr>
                                <td>Lower bound</td>
                                <td>{data.lowerBound}</td>
                            </tr>
                            <tr>
                                <td>Median</td>
                                <td>{data.median}</td>
                            </tr>
                        </tbody>
                    </table>
                );
                renderedDataTables.push(table);
            }
        }

        return (
        <>
            <div id="boxplotsContainer" style={{width: "100%" , marginTop:"20px"}}>
                <table style={{border:"1px lightgray solid", width:"100%"}}>
                    <thead>
                        <tr style={{height:"40px", background:"lightgray"}}>
                            <th style={{paddingLeft:"20px"}}>
                                <span>{this.state.boxplotData.name}</span>
                                <Link to={"#"}>
                                    <span title="Delete graph"
                                        className="glyphicon glyphicon-trash"
                                        style={{float:"right", marginRight:"15px", marginTop:"2px"}}
                                        onClick={this.handleDelete} />
                                </Link>
                                <Link to={"#"}>
                                    { this.state.boxplotData.pinnedToDashboard ?
                                        <span title="Remove this graph from details dashboard"
                                            className="glyphicon glyphicon-bookmark"
                                            style={{float:"right", marginRight:"15px", marginTop:"2px", color:"darkred"}}
                                            onClick={this.removeFromDashboard} /> :
                                        <span title="Show this graph in details dashboard"
                                            className="glyphicon glyphicon-bookmark"
                                            style={{float:"right", marginRight:"15px", marginTop:"2px"}}
                                            onClick={this.addToDashboard} />
                                    }
                                </Link>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td style={{padding: hasData ? "0" : "20px"}}>
                                {!hasData ? (
                                    <div style={{
                                        padding: "14px 18px",
                                        background: "#fffbeb",
                                        border: "1px solid #fde68a",
                                        borderRadius: "6px",
                                        textAlign: "center",
                                        fontSize: "13px",
                                        color: "#92400e"
                                    }}>
                                        <strong>No data available.</strong>
                                    </div>
                                ) : (
                                    <div id={"boxplot" + this.state.boxplotIndex} />
                                )}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

            {hasData && (
                <>
                    <button style={{marginTop:"10px", marginBottom: "10px", paddingLeft:"30px", paddingRight:"30px"}}
                                    className="btn btn-default" onClick={this.toggleTableData}
                                    title="Show table of computed boxplot values">CI TABLE</button>

                    <div className="form-group" style={{width: "100%"}} hidden={this.state.hideTableData}>
                        {renderedDataTables}
                    </div>
                </>
            )}
        </>
        );
    }
}

export default PartBoxplotPanel;